import { Box } from "@mui/material";
import Header from "../../../../components/Header";
import React, { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import themes from "devextreme/ui/themes";
import { useDispatch, useSelector } from "react-redux";

import {
  getRequest,
  setFilter,
} from "../../../../store/reducers/requestVehicle";
import RequestInData from "../../../../components/request/admin/vehicle/requestInData";
import RequestConfirmedData from "../../../../components/request/admin/vehicle/requestConfirmed";

const RequestVehicle = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  return (
    <Box m="20px">
      <Header
        title="Тээврийн хэрэгсэл"
        subtitle="Тээврийн хэрэгслийн хүсэлтүүд жагсаалт"
      />
      <Stack>
        <Box>
          <RequestInData />
        </Box>
        <Box height={12}></Box>
        <Box>
          <RequestConfirmedData />
        </Box>
      </Stack>
    </Box>
  );
};

export default RequestVehicle;
